export default function registerGlobalVueFilters(Vue) {

    Vue.filter('migrolFormatText', function (value) {

        if (typeof value !== 'string' || value === '') return '';

        return value
            .replace(/(\b|\d)(m2)(?=\b|$)/, function (g0, g1) { return g1 + 'm<sup>2</sup>' })
            .replace(/(\b|\d)(m3)(?=\b|$)/, function (g0, g1) { return g1 + 'm<sup>3</sup>' })
            .replace(/(\b|\^)(CO2)(?=\b|$)/, function (g0, g1) { return g1 + 'CO<sub>2</sub>' })
            .replace('®', '<sup>&reg;</sup>');
    });
}